module.exports = __webpack_public_path__ + "static/img/produto_p.e75a834.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/agua-coco/produto_p.png
// module id = AaoX
// module chunks = 0